const domainAppUserEn = {
  appUser: "User",
  component: {
    AppUserActionButton: {
      createUser: "Create User",
      toolTipCreateUserOnWebPage:
        'Please Action "Create User" in the {{name}} Web page',
      deactivateUser: "Deactivate User",
      toolTipDeactivateUserOnWebPage:
        'Please Action "Deactivate User" in the {{name}} Web page',
      reactivateUser: "Reactivate User",
      toolTipReactivateUserOnWebPage:
        'Please Action "Reactivate User" in the {{name}} Web page',
      describe: "Do you want to delete this account?",
      noRecommendedAction: "No recommended action",
    },
    ChangePersonDialog: {
      changePersonTitle: "Change Person",
      assignPersonTitle: "Assigning person to unidentified account",
      noPerson: "No Person associated",
      selectInputPlaceholder: "Select Person...",
      noPersonFound: "No person found.",
      Edit: "Edit",
      unidentifiedAccount: "Unidentified account",
      assignTo: "Assign to",
    },

    LastActivityCell: {
      inactiveFor: "Inactive for {{value}}",
    },
  },
};

export default domainAppUserEn;
